<template>
  <input-dropdown
    v-slot="{ item: chart }"
    :options="charts"
    :value="chartConfig"
    :placeholder="$t('placeholders.selectChartType')"
    @update:value="emit('update:chartType', $event.id as ChartType)"
  >
    <span v-if="chart?.id" :key="chart.id">
      <lucide-icon :name="chart.icon" />
      <span class="ml-1">{{ $t(`chartTypes.${chart.id}`) }}</span>
    </span>
    <span v-else>{{ $t('placeholders.selectChartType') }}</span>
  </input-dropdown>
</template>

<script setup lang="ts">
import { computed } from "vue";
import InputDropdown from "@core/input/InputDropdown.vue";
import LucideIcon from "@core/ui/LucideIcon.vue";

import { charts } from "./charts";
import type { ChartType } from "./ChartItem";

const props = defineProps<{
  chartType: ChartType | null;
}>();
const emit = defineEmits<{
  (e: "update:chartType", chartType: ChartType): void;
}>();

const chartConfig = computed(() => {
  if (!props.chartType) {
    return null;
  }
  return charts[props.chartType] || null;
});
</script>

<style lang="scss"></style>
